module.exports = __webpack_public_path__ + "assets/img/editDisabled.17d8396d.svg";